<template>
  <div class="personal-list">
    <Row :gutter="12">
      <Col :span="5">
        <Card>
          <Tree :data="unitList" :key="Math.random()" @on-select-change="treeChange"></Tree>
        </Card>
      </Col>
      <Col :span="19">
        <Card>
          <div style="display: flex;flex-direction: row">
            <div>
              姓名：<Input type="text" v-model="formInline.name" placeholder="请输入姓名" style="width: 200px">
            </Input>
            </div>
<!--            <div style="margin-left: 8px">-->
<!--              单位：<Input type="text" v-model="formInline.unit" placeholder="请输入单位" style="width: 200px">-->
<!--            </Input>-->
<!--            </div>-->
            <Button type="primary" @click="getAllPersonal" style="margin-left: 8px">查询</Button>
          </div>
          <div style="text-align: right;margin-top: 10px">
<!--            <Button type="primary" @click="" style="margin-left: 4px" disabled>同步应急会商单位名称信息</Button>-->
<!--            <Button type="primary" @click="" style="margin-left: 4px" disabled>应急群组</Button>-->
            <Button code="emergency.personal.add" type="primary" @click="gotoAdd" style="margin-left: 4px">新增</Button>
<!--            <Button type="primary" @click="" style="margin-left: 4px" disabled>导入</Button>-->
<!--            <Button type="primary" @click="" style="margin-left: 4px" disabled>导出</Button>-->
<!--            <Button type="primary" @click="" style="margin-left: 4px" disabled>模版下载</Button>-->
<!--            <Button type="primary" @click="" style="margin-left: 4px" disabled>批量删除</Button>-->
<!--            <Button type="primary" @click="" style="margin-left: 4px" disabled>批量维护</Button>-->
          </div>
          <div style="margin-top: 10px">
            <Table
                :loading="dataLoading"
                :columns="columns"
                :data="data"
                :border="false"
                :stripe="false"
                :highlight-current-row="true"
            >
              <template #action="{ row, index }">
                <div style="display: flex">
                  <Button  class="btn" ghost style="flex: 1;color: #00a6ef" size="small"   code="emergency.personal.edit" type="text" v-if="row.flag" @click="editPro(row)">编辑</Button>
                  <Button  class="btn"  ghost style="flex: 1;color: red" size="small"  code="emergency.personal.delete" type="text" v-if="row.flag" @click="deletePeople(row)" >删除</Button>
                </div>
              </template>
            </Table>
            <Page style="text-align: right;margin-top: 10px"
                  show-sizer
                  show-total
                  transfer
                  :total="dataTotal"
                  :page-size="pageSize"
                  :page-size-opts="pageSizeOpts"
                  :current-page="currentPage"
                  @on-change="pageChange"
                  @on-page-size-change="pageSizeChange"
            ></Page>
          </div>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  name: "personalList",
  data() {
    return {
      unitList: [],
      selectUnit: 1,
      buttonProps: {
        type: 'default',
        size: 'small',
      },
      formInline: {
        name: '',
        unit: ''
      },
      ruleInline: {},
      dataLoading: false,
      dataTotal: 0,
      columns: [
        {
          title: '姓名',
          align: 'center',
          // width: '120',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.personalAddressBook.name)
          }
        },
        {
          title: '单位',
          key: 'reporter',
          align: 'center',
          // width: '120',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.unitName)
          }
        },
        {
          title: '所属科室',
          key: 'reporter',
          align: 'center',
          // width: '120',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.personalAddressBook.belongDepartment)
          }
        },
        {
          title: '职务',
          key: 'reporter',
          align: 'center',
          // width: '120',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.personalAddressBook.job)
          }
        },
        {
          title: '手机',
          key: 'reporter',
          align: 'center',
          // width: '120',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.personalAddressBook.phone)
          }
        },
        {
          width: '100',
          title: '操作',
          // fixed: 'right',
          align: 'center',
          slot: 'action',
        }
      ],
      data: [],
      pageSize: 10,
      pageSizeOpts: [10, 20, 30, 40],
      currentPage: 1,
      curUserId: ''
    }
  },
  watch: {
    userInfo: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          console.log(newVal)
          this.curUserId = newVal.userId
        }
      }
    }
  },
  computed: {
    userInfo: {
      get: function () {
        console.log(this.$store)
        return this.$store.state.user.userInfo
      },
      set: function () {
      }
    }
  },
  mounted() {
    this.getAllPersonal()
    this.getAllUnit()
  },
  methods: {
    treeChange(value){
      console.log(value)
      this.selectUnit = value[0].value
      console.log(this.selectUnit)
      if(this.selectUnit !== 1){
        this.unitList[0].selected = false
      }
      this.$forceUpdate()
      this.getAllPersonal()
    },
    gotoAdd() {
      this.$router.push({
        name: 'addPersonPhone',
      })
    },
    editPro(row) {
      this.$router.push({
        name: 'addPersonPhone',
        params: {
          row: row
        }
      })
    },
    getAllUnit(){
      this.$http.get('/api/unit/getAll').then(res => {
        // console.log(res)
        this.unitList = res.data.data
        this.unitList = this.unitList.map(item => {
          if(item.value === this.selectUnit) {
            item.selected = true
          }
          return item
        })
        console.log(this.unitList)
      })
    },
    getAllPersonal(){
      this.formInline.unit = this.selectUnit
      this.dataLoading = true
      this.$http.post(`/api/pab/getAll?page=${this.currentPage}&&size=${this.pageSize}`, this.formInline).then(res => {
        // console.log(res)
        this.data = res.data.data.list
        this.dataTotal = res.data.data.total
        this.dataLoading = false
      })
    },
    deletePeople(row){
      var id = parseInt(row.personalAddressBook.id)
      var list = []
      list.push(id)
      this.$http.post('/api/pab/delete', list).then(res => {
        // console.log(res)
        this.getAllPersonal()
      })
    },
    pageChange(page) {
      this.currentPage = page
      this.getAllPersonal()
    },
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.getAllPersonal()
    },
  }
}
</script>

<style scoped lang="less">
.personal-list {

}
.btn{
  & .disabled {
    color: #ccc!important;
  }
}
</style>
